import { cx } from '@orn/shared-web/utils/cx';

import { listedAlertToAlertRow } from '../../utils/alert/alertRow';
import AlertTypeIcon from '../AlertTypeIcon';

import type { AlertRowFields } from '../../utils/alert/alertRow';

interface IAlertCardHeaderProps {
  /**
   * The alert this turn was opened on, or `null` when it does not resolve.
   * Two ways to get there: the lookup has not returned yet, or the row is gone
   * — deleted outright, or cascaded away with the transaction it hung off.
   * Archival is *not* one of them: `useAlertCardWorkItems` deliberately skips
   * the archived filter precisely so a card outlives its alert's active life.
   */
  alert: AlertRowFields | null;
  className?: string;
}

/** Stands in for an alert that no longer resolves, so the turn keeps its subject. */
const MISSING_ALERT_TITLE = 'Alert no longer available';

/**
 * Opens an alert-expand turn in the transcript: the logo of what the alert is
 * about, and the alert's headline. The assistant's answer follows underneath as
 * ordinary prose, so this is the only part of the turn the user can tie back to
 * the row they clicked.
 *
 * The title is derived through `listedAlertToAlertRow`, never read off
 * `alert.title` — the strip row derives its headline the same way, so the card
 * and the row it was opened from cannot word the alert differently. The
 * derivation also keeps the metadata-composition fallback for a fixture with no
 * authored title (the `FigmaReference` story's case).
 */
const AlertCardHeader = ({ alert, className }: IAlertCardHeaderProps) => (
  <div className={cx('flex w-full items-center gap-3', className)}>
    {alert !== null && <AlertTypeIcon alert={alert} className="size-8 rounded-md" />}
    <span className="text-primary text-xl font-semibold">
      {alert === null ? MISSING_ALERT_TITLE : listedAlertToAlertRow(alert).title}
    </span>
  </div>
);

export default AlertCardHeader;
